import { render, staticRenderFns } from "./ModalTagCreate.vue?vue&type=template&id=0274298b"
import script from "./ModalTagCreate.vue?vue&type=script&lang=js"
export * from "./ModalTagCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports